export enum eTypePosition {
  Venta = 1,
  Transito = 2,
  Caja = 3,
  Diferencia = 5,
  Recepcion = 6,
  Despacho = 7,
  PreDespacho = 8,
  DevolucionProveedor = 12,
  Cancelacion = 13,
  DevolucionRecepcion = 15,
  Reposicion = 17,
  Draft = 18,
  Calidad = 19,
  CalidadRecepcion = 20,
  CalidadValidacion = 21,
  CalidadValidacionDraft = 22,
  CalidadDevolucion = 23,
  CalidadDevolucionDraft = 24,
  StagingSalida = 25,
  CalidadTransferencia = 26,
  CalidadCaja = 27,
  DraftReserva = 28,
  Reserva = 29,
  DiferenciaDraft = 30,
  CalidadTransferenciaDraft = 31
}
